import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useClientes from "../../hooks/useClientes";
import { useAuth } from "../../auth/AuthContext";
import {
  validarCPF,
  aplicarMascaraCPF,
  aplicarMascaraCEP,
  aplicarMascaraTelefone
} from "../../utils/formatadores";

// Lista de campos obrigatórios
const camposObrigatorios = [
  "nomeCliente",
  "cpf",
  "dataNascimento",
  "telefone",
  "rua",
  "numero",
  "bairro",
  "cidade",
  "estado"
];

const rotulosCampos = {
  nomeCliente: "Nome do Cliente",
  cpf: "CPF",
  dataNascimento: "Data de Nascimento",
  telefone: "Telefone",
  email: "E-mail",
  cep: "CEP",
  rua: "Rua",
  numero: "Número",
  bairro: "Bairro",
  cidade: "Cidade",
  estado: "Estado / UF",
  indicadoPor: "Indicado por"
};

const CadastroClientePage = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const { cadastrarCliente } = useClientes();
  const [actionType, setActionType] = useState(null);

  const [novoCliente, setNovoCliente] = useState({
    nomeCliente: "",
    cpf: "",
    dataNascimento: "",
    telefone: "",
    email: "",
    cep: "",
    rua: "",
    numero: "",
    bairro: "",
    cidade: "",
    estado: "",
    indicadoPor: ""
  });

  if (loading) return <p>Carregando...</p>;
  if (!user) return <p>Não autorizado</p>;
  if (
    user.role !== "admin" && 
    user.role !== "advogado" && 
    user.role !== "advogado_parceiro" &&
    user.role !== "estagiario" &&
    user.role !== "recepcionista"
  ) {
    return <p>Acesso negado</p>;
  }

  const handleInputChange = (campo, valor) => {
    let valorFormatado = valor;

    if (campo === "cpf") {
      valorFormatado = aplicarMascaraCPF(valor);
    } else if (campo === "cep") {
      valorFormatado = aplicarMascaraCEP(valor);
    } else if (campo === "telefone") {
      valorFormatado = aplicarMascaraTelefone(valor);
    } else if (campo === "dataNascimento") {
      const partes = valor.split("-");
      if (partes[0] && partes[0].length > 4) {
        partes[0] = partes[0].slice(0, 4);
        valorFormatado = partes.join("-");
      }
    }

    setNovoCliente((prev) => ({
      ...prev,
      [campo]: valorFormatado
    }));
  };

  const processarCadastro = async () => {
    // Validação de campos obrigatórios
    for (const campo of camposObrigatorios) {
      if (!novoCliente[campo] || !novoCliente[campo].trim()) {
        alert(`O campo "${rotulosCampos[campo] || campo}" é obrigatório.`);
        return null;
      }
    }

    if (!validarCPF(novoCliente.cpf)) {
      alert("CPF inválido");
      return null;
    }

    return await cadastrarCliente(novoCliente);
  };

  const handleCadastrarCliente = async (e) => {
    e.preventDefault();
    setActionType("cadastrar");
    try {
      const cliente = await processarCadastro();
      if (cliente) {
        alert("Cliente cadastrado com sucesso!");
        navigate("/recepcao/recepcao");
      }
    } catch (error) {
      alert("Erro ao cadastrar cliente: " + error.message);
    } finally {
      setActionType(null);
    }
  };

  const buscarCep = async () => {
    const cep = novoCliente.cep.replace(/\D/g, "");
    if (cep.length !== 8) return;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const data = await response.json();

      if (data.erro) {
        alert("CEP não encontrado");
        return;
      }

      setNovoCliente((prev) => ({
        ...prev,
        rua: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        estado: data.uf || ""
      }));
    } catch {
      alert("Erro ao buscar o CEP. Verifique sua conexão.");
    }
  };

  return (
    <div className="container">
      <div className="card">
        <h1>CADASTRAR NOVO CLIENTE</h1>

        <form onSubmit={handleCadastrarCliente}>
          <div className="form-grid">
            {Object.keys(novoCliente).map((campo) => {
              const isObrigatorio = camposObrigatorios.includes(campo);

              return (
                <div className="form-group" key={campo}>
                  <label>
                    {rotulosCampos[campo] || campo}
                    {isObrigatorio && <span style={{ color: "red" }}> *</span>}
                  </label>
                  <input
                    type={campo === "dataNascimento" ? "date" : "text"}
                    name={campo}
                    placeholder={rotulosCampos[campo] || campo}
                    value={novoCliente[campo] || ""}
                    required={isObrigatorio}
                    max={campo === "dataNascimento" ? "9999-12-31" : undefined}
                    min={campo === "dataNascimento" ? "1900-01-01" : undefined}
                    maxLength={
                      campo === "cpf" ? 14 : campo === "cep" ? 9 : undefined
                    }
                    onChange={(e) => handleInputChange(campo, e.target.value)}
                    onBlur={campo === "cep" ? buscarCep : undefined}
                  />
                </div>
              );
            })}
          </div>

          <button 
            className="btn-salvar" 
            type="submit"
            disabled={actionType !== null}
          >
            {actionType === "cadastrar" ? (
              <span className="spinner-loader"></span>
            ) : (
              "Cadastrar"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CadastroClientePage;